<template>
  <div class="serivce">
    <h1>关于软件服务费的介绍</h1>
    <p>
      1、收费说明：<br>
      基于平台向客户提供了信息资源展示，线上竞价交易等软件服务，平台收取相关软件服务费用。<br>
      2、收费条件：<br>
      以系统成交为准，即只要标的通过系统网络竞价流程成交，竞买人即应按照本规则向拍界平台支付软件服务费，包含系统成交后发生竞拍不买、成交不卖的交易（因网络原因导致的除外）。<br>
      3、不收费情形：<br>
      系统交易失败的情形，包含流拍，撤回，中止。 <br>
      4、收费标准：<br>
      按系统成交价金额进行计算，单个标的软件服务费金额上限为200万（人民币：贰佰万圆整）。其中：系统成交价=起拍价+溢价。 <br>
      5、缴费方式：<br>
      线下支付：标的物竞拍成功后，买受人将软件服务费转至拍界如下官方指定账户<br>
      公司名称：吉林省拍界科技有限责任公司<br>
      开户行：中国邮政储蓄银行股份有限公司长春同志街支行<br>
      账号：92200 30100 8970 8888<br>
      （若买受人未足额支付软件服务费，平台将锁定竞拍保证金直至买受人线上完成软件服务费订单的支付）。 <br>
      6、缴费期限：<br>
      软件服务费的缴纳期限为订单生成之日起的3个工作日内，买受人逾期未全额缴纳的，平台可对其进行依法追缴。<br>
    </p>
    <!-- <span @click="goBack">返回></span> -->
  </div>
</template>

<script>
export default {
  metaInfo: {
    title: "拍界——唤醒您的沉睡资产",
    meta: [{
      name: "keywords",
      content: "拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
    }, {
      name: "description",
      content: "拍界是一个专注拍卖的网络平台，拍卖无边界，拍卖更便捷。拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
    }]
  },
  methods: {
    goBack: function () {
      this.$router.go(-1)
    }
  }
}
</script>